// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__lpR3a","load8":"LoadingSpinner_load8__39z1+"};